import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, MessageSquare, Bookmark, Eye } from 'lucide-react';
import { useLikeCase, useSaveCase, useSavedCases } from '../hooks/use-cases';


const CaseActions = ({ caseId, supportCount = 0, commentCount = 0, isLiked = false, hideSave = false, customAction }) => {
  const navigate = useNavigate();
  const { mutate: likeCase, isPending: isLiking } = useLikeCase();
  const { mutate: saveCase, isPending: isSaving } = useSaveCase();
  const { data: savedCasesData } = useSavedCases(1, 100);
  
  const saved = savedCasesData?.data?.some(c => c.id === caseId) || false;
  


  return (
    <div className="flex items-center justify-between mt-4 pt-3 border-t border-gray-100">
      <div className="flex items-center gap-4">
        <button
          id="support-btn"
          onClick={() => likeCase(caseId)}
          disabled={isLiking}
          className={`flex items-center gap-1.5 text-sm transition-colors duration-200
                     ${isLiked ? 'text-red-500' : 'text-light-gray hover:text-red-500'}`}
        >
          <Heart size={16} fill={isLiked ? 'currentColor' : 'none'} />
          <span>{supportCount}</span>
          <span className="hidden sm:inline">Appreciate</span>
        </button>
        <button className="flex items-center gap-1.5 text-sm text-light-gray hover:text-accent-indigo transition-colors duration-200">
          <MessageSquare size={16} />
          <span>{commentCount}</span>
          <span className="hidden sm:inline">Clinical Input</span>
        </button>

      </div>
      <div className="flex items-center gap-2">
        {!hideSave && (
          <button
            onClick={() => saveCase(caseId)}
            disabled={isSaving}
            className={`flex items-center gap-1.5 text-sm transition-colors duration-200
                       ${saved ? 'text-accent-indigo' : 'text-light-gray hover:text-accent-indigo'}`}
          >
            <Bookmark size={16} fill={saved ? 'currentColor' : 'none'} />
            <span className="hidden sm:inline">Save</span>
          </button>
        )}
        {customAction ? customAction : (
          <button
            onClick={() => navigate(`/cases/${caseId}`)}
            className="flex items-center gap-1.5 text-sm text-white bg-accent-indigo hover:bg-accent-indigo/90
                       px-3 py-1.5 rounded-full transition-all duration-200 font-medium ml-2"
          >
            <Eye size={14} />
            <span>View Case</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default CaseActions;